export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/pl.lyaml"));
at({ "pl": { "public": { "sampleString": "Przyk\u0142adowy ci\u0105g znak\xF3w" } } });
};